import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
import { connect } from "react-redux";
import Page from "../../Page/Page";
import { closeTermsConditionModal } from "../../../actions/modalActions";

class TermsAndCondition extends Component {

    render() {
        const { isTermsModalOpen, closeTermsConditionModal, termsConditions } = this.props;

        return (
            <Modal show={isTermsModalOpen} animation={false} onHide={closeTermsConditionModal} dialogClassName='loginModal termsAndConditionPopup'>
                <Modal.Header closeButton>
                    <Modal.Title>{termsConditions?.pageName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <Page html={termsConditions.content} title={termsConditions.metaTitle} />
                </Modal.Body>
            </Modal>
        )
    }
}

const mapState = (state) => ({
    isTermsModalOpen: state?.modalStatus?.isTermsModalOpen,
});

const mapDispatch = {
    closeTermsConditionModal
};

export default connect(mapState, mapDispatch)(TermsAndCondition);